import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Select } from '../../../../../../../../CommonComponents/OPL/Select/Select/Select';
import { Input } from '../../../../../../../../CommonComponents/OPL/Input/Input';
import { FormFields, YEAR_INHERITED_OPTIONS } from '../../AccountForm.meta';
import { useAccountFormContext } from '../../context/useAccountFormContext';
import {
  POST_2020_OPTIONS,
  getIraDistributionStartYearOptions,
} from './InheritedIRADistributionOptions.meta';

export const InheritedIRADistributionOptions = () => {
  const {
    options: { IraDistributionMethodOptions },
  } = useAccountFormContext();

  const formBag = useFormContext<FormFields>();

  const { register, control, watch } = formBag;

  const [yearInherited, distributionCalculationMethod] = watch([
    'bankAccount.YearInherited',
    'bankAccount.DistributionCalculationMethod',
  ]);

  const iraDistributionStartYearOptions = getIraDistributionStartYearOptions(yearInherited);

  const isPost2020 = yearInherited && yearInherited > 2020;

  return (
    <>
      <Controller
        control={control}
        name="bankAccount.YearInherited"
        render={({ field: { value, onChange, ...field } }) => {
          return (
            <Select
              {...field}
              isPortal
              options={YEAR_INHERITED_OPTIONS}
              label="Year Inherited"
              value={value ? { label: value.toString(), value } : null}
              onChange={opt => {
                formBag.setValue('bankAccount.IraDistributionStartYear', null);
                onChange(opt?.value);
              }}
            />
          );
        }}
      />

      {isPost2020 ? (
        <Controller
          control={control}
          name="bankAccount.DistributionCalculationMethod"
          render={({ field: { value, onChange, ...field } }) => {
            return (
              <Select
                {...field}
                isPortal
                value={POST_2020_OPTIONS.find(option => option.value === value) ?? null}
                options={POST_2020_OPTIONS}
                onChange={opt => onChange(opt?.value)}
                label="Distribution Method"
              />
            );
          }}
        />
      ) : (
        <Controller
          control={control}
          name="bankAccount.IraDistributionMethod"
          render={({ field: { value, onChange, ...field } }) => {
            return (
              <Select
                {...field}
                isPortal
                value={IraDistributionMethodOptions.find(option => option.value === value) ?? null}
                options={IraDistributionMethodOptions}
                onChange={opt => onChange(opt?.value)}
                label="Distribution Method"
              />
            );
          }}
        />
      )}

      {yearInherited && (
        <Controller
          control={control}
          name="bankAccount.IraDistributionStartYear"
          render={({ field: { value, onChange, ...field } }) => {
            return (
              <Select
                {...field}
                isPortal
                value={value ? { value, label: value.toString() } : null}
                options={iraDistributionStartYearOptions}
                onChange={opt => onChange(opt?.value)}
                label="Distribution Start Year"
                {...(yearInherited === null ? { placeholder: 'Missing Year Inherited' } : {})}
              />
            );
          }}
        />
      )}

      {yearInherited !== null && !(isPost2020 && distributionCalculationMethod === 0) && (
        <Input
          {...register('bankAccount.IraDistributionSchedule')}
          label="Distribution Schedule"
          tooltip="List distribution percentages for each year between the current year and the 10th year after inheritance. For example, entering 80, 20, followed by 0 values for subsequent years indicates distribution 80% of the balance in the first year and the remaining 20% in the second year, while 20, 20, 20, 20, 20, followed by 0 values for subsequent years would distribute 20% each year for 5 years."
        />
      )}
    </>
  );
};
